// filo-takip/src/components/PrivateRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { user, role, userPermissions, loading } = useAuth();
  const location = useLocation();

  // Auth yüklenene kadar bekle
  if (loading) return <div style={{ textAlign: "center", marginTop: 40 }}>Yükleniyor...</div>;

  // Giriş yapılmamış
  if (!user || !role) return <Navigate to="/secilen-proje" replace />;

  const normalizedRole = (role || "").toLocaleLowerCase("tr");
  const isCreator = normalizedRole === "oluşturucu";

  // Oluşturucu → her yere girebilir
  if (isCreator) return children;

  // userPermissions henüz yüklenmediyse bekle (asenkron geldiği için)
  if (userPermissions === null || userPermissions === undefined) {
    return <div style={{ textAlign: "center", marginTop: 40 }}>Yükleniyor...</div>;
  }

  const perms = userPermissions?.filotakip || {};
  const path = location.pathname.toLowerCase();

  // Sayfa bazlı yetki kontrolü
  if (path.includes("arac-listesi")   && perms.takip)    return children;
  if (path.includes("puantaj")        && (perms.yonetici || perms.giris)) return children;
  if (path.includes("belge-yukleme")  && (perms.takip || perms.giris)) return children;
  if (path.includes("belge-yonetimi") && (perms.yonetici || perms.takip)) return children;
  if (path.includes("admin")          && isCreator)      return children;

  // Hiçbir kural eşleşmedi → yetkisiz
  return (
    <div style={{ textAlign: "center", marginTop: 60, fontFamily: "system-ui" }}>
      <h3>Yetkisiz Erişim</h3>
      <p style={{ color: "#6b7280" }}>Bu sayfayı görüntülemek için gerekli yetkiniz bulunmamaktadır.</p>
      <a href="/secilen-proje" style={{ color: "#1e40af" }}>← Proje seçimine dön</a>
    </div>
  );
};

export default PrivateRoute;
